import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IAppState } from '../../../../../../app';
import { IBasePageProps } from '../../../../configuration/IConfiguration';
import { Link } from 'react-router-dom';
import * as classNames from "classnames";
import AdminContactEmailLink from '../../../../../Content/AdminContactEmailLink';


type PageHelpProps = {
}

type PageHelpActions = {
}

type PageHelpRouteParams = {
    helpSection?: string;
}

type PageHelpQueryParams = {
}

type PageHelpPropsMapped = {
}

type PageHelpActionsMapped = {
}

type PageHelpAllPropsInherited = PageHelpProps & PageHelpActions;
type PageHelpAllPropsMapped = PageHelpPropsMapped & PageHelpActionsMapped;

type PageHelpAllProps = IBasePageProps<PageHelpRouteParams, PageHelpQueryParams> & Partial<PageHelpAllPropsMapped> & PageHelpAllPropsInherited;

class PageHelp extends React.Component<PageHelpAllProps, any> {
    constructor(props, context) {
        super(props, context);
    }

    render() {
        const dataSection = <>
            <h3>How to enter and upload a data record</h3>
            <div className="ml-3">
                <h5><strong>Step 1.</strong> Enter data</h5>
                <ul>
                    <li>On the My Data page, select the site where the scan was conducted.</li>
                    <li>Select the date when the scan occurred (taking particular care if the scan date differs from the current/default date).</li>
                    <li>Select the time when the scan was completed (taking particular care if the finish time of the scan differs by more than a minute or so from the current/default time).</li>
                    <li>Select the number of platypus seen, making sure that you record a "0" if no platypus were seen during the scan. <strong>Negative sightings (when no platypus are seen in a scan) are just as important to accurate monitoring as positive sightings.</strong></li>
                </ul>
                <h5><strong>Step 2.</strong> Submit data</h5>
                <ul>
                    <li>Press “Submit” to upload the data record. You will then be given a chance to review your entry details and press "OK" (to upload) or "Cancel" (if you want to go back and correct the record).</li>
                    <li>Go back to the My Data page if you want to report additional data records for other sites.</li>
                </ul>
            </div>
            <h3>How to correct a mistake in a data record after it's been uploaded</h3>
            <div className="ml-3">
                <p>
                    Go to the APMN website, login, go to My Data, and select Add Data for the site associated with the error. Delete the incorrect entry from the list provided (showing the 5 most recent records for that site), then replace the deleted entry by submitting a new record with correct details.
            </p>
                <p>
                    If you realise that an even earlier error has to be corrected, please contact the APC by email (<AdminContactEmailLink/>).
            </p>
            </div></>

        const selectSection = <>
            <h3>How to register your monitoring sites</h3>
            <div className="ml-3">
                <p>When you click on Site Selection, a map will appear showing previously registered platypus monitoring sites that are (1) available for monitoring by any registered APMN volunteer (Public Sites), (2) located on private land and only monitored by the landowner (Private Sites), or (3) new sites that are currently under evaluation (Proposed Sites).  </p>
                <p>To select and add a site to your personal list of monitoring sites:</p>
                <h5><strong>Step 1.</strong> Find your area of interest on the map </h5>
                <ul>
                    <li>Zoom in to the area where you wish to monitor to see if any Public Sites already exist.</li>
                </ul>
                <h5><strong>Step 2.</strong> Select an existing Public Site</h5>
                <ul>
                    <li>Click on the site marker for a Public Site that you potentially wish to monitor. A site details summary box will appear and confirm if the site is Active or Inactive (meaning it hasn’t been monitored by any APMN volunteer in the current or previous seasonal quarters).  Click “View Data” to open a page summarising the site’s monitoring history.</li>
                    <li>If you decide to monitor this site, next click “Select Monitoring Site”. The site will now be added to the list of sites shown on your My Data page and you can Add Data whenever you wish. </li>
                </ul>
                <h5><strong>Step 3.</strong> If no suitable Public Sites are available, register a new monitoring site</h5>
                <ul>
                    <li>Click on the proposed location of a new site and a “Create New Site” page will appear.  You will need to fill in some details (the name of the water body to be monitored and the name of the nearest town, village or suburb) and give the site a name.  Please choose a short but descriptive name that will be meaningful to possible future users – for example, “End of Green Street” or “North end of Greentown sports oval” – rather than something that will only be meaningful to you, such as “B2, by large tree”.</li>
                    <li>If the site is on your own private land and you would prefer that it’s only monitored by yourself and your family, then tick the box for “Site is Private Property”.</li>
                    <li>When you are finished, click “Save”. You will then be given a chance to review your entry details and press “OK” (to upload) or “Cancel” (to first go back and correct any mistakes that you may have made).  Once you press “OK”, the site will be added to the list of sites shown on your My Data page and will be shown on the map as a Proposed Site under evaluation. To be reclassified as a Public or Private Site, at least one platypus sighting must be recorded at a Proposed Site in a minimum trial period of 20 scans.</li>
                </ul>
            </div>
            <h3>How to change monitoring site details</h3>
            <div className="ml-3">
                <p>
                    If there’s a clear need to change a monitoring site’s name or location (because the current description no longer applies), please send an email to the APC (<AdminContactEmailLink/>).
                </p>
            </div></>

        const selectTab = !this.props.routeParams.helpSection || this.props.routeParams.helpSection === 'sites';

        return (
            <div className="m-4">
                <div className="col-12 border-bottom my-2 pb-2"><h2 className="m-0">Help</h2></div>
                <div className="row">
                    <div className="col-md-4 col-xl-2 col-12 list-group mb-3">
                        <Link className={classNames("list-group-item list-group-item-action", { "active": selectTab })} to="/help/sites">Selecting A Site</Link>
                        <Link className={classNames("list-group-item list-group-item-action", { "active": !selectTab })} to="/help/data">Adding Data</Link>
                    </div>
                    <div className="col-md-8 col-xl-10 col-12">
                        {selectTab ? selectSection : dataSection}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: PageHelpAllProps): PageHelpPropsMapped => {

    return {
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators<PageHelpActionsMapped>({
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)<PageHelpAllPropsInherited>(PageHelp);